
import React from "react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Home } from "lucide-react";

export function HomeButton({ onClick }) {
  return (
    <motion.div
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      className="fixed top-24 left-6 z-50"
    >
      <Button
        onClick={onClick}
        variant="ghost"
        className="w-12 h-12 rounded-full bg-[#1a1a2e] hover:bg-[#1a1a2e]/80 border border-[#ff3366]/20"
      >
        <Home className="h-6 w-6 text-[#ff3366]" />
      </Button>
    </motion.div>
  );
}
